<template>
    <div class="mt-5">
        <v-layout row>
            <v-flex md6>
                <h3>{{data.title}}</h3>
            </v-flex>
            <v-flex md6 class="text-md-right">

                <a
                  v-if = "data.export_url && data.data.length"
                  :href = "data.export_url"
                  class = "excel-btn"
                  target = "_blank">
                      Download Data
                </a>
                <JsonExcel
                  v-else
                  class="excel-btn"
                  :data = "data.data">
                    Download Data
                </JsonExcel>

            </v-flex>
        </v-layout>
        <v-data-table
          :headers="headers"
          :items="data.data"
          class="mt-3"
        >
            <template v-slot:items="props">
                <td class="text-xs-center" v-for="(value, key) in props.item" v-if="key !== 'inner_table'"  @click="openInnerTable(props.item.inner_table)">
                    {{ value ? value : '-' }}
                </td>
            </template>
        </v-data-table>
        <v-dialog v-model="dialog" width="1600" v-if="selectedInnerData.data_url">
            <v-card class="pa-5">
                <dynamic-table :data="selectedInnerData"/>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import common from '../../../utils/common'
    import JsonExcel from 'vue-json-excel'
    import dynamicTable from './dynamic-table'
    export default {
        name: "table",
        components: {
            JsonExcel,
            dynamicTable
        },
        props: {
            data: {
                type: Object,
                default: ()=> {
                    return {}
                }
            }
        },
        data () {
            return {
                common,
                headers: [

                    // { text: 'Actions', value: 'name', sortable: false, align: 'center', }
                ],
                dialog: false,
                selectedInnerData: {}
            }
        },
        mounted() {
            for (let property in this.data.data[0]) {
                if (this.data.data[0].hasOwnProperty(property)) {
                    if (property !== 'inner_table') {
                        this.headers.push(
                          {
                              text: property.replace(/ /g,"_"),
                              align: 'center',
                              sortable: false,
                              value: property
                          },
                        )
                    }

                }
            }
        },
        methods: {
            openInnerTable(data) {
                this.selectedInnerData = data
                this.dialog = true
            }
        }
    }
</script>

<style >

    .v-table__overflow > table thead {
        background-color: #f4f5f9;
        border-radius: 8px !important;
    }
</style>
